import { useTranslation } from 'react-i18next';

import { Breadcrumbs, PageTitle } from 'core/components';
import { LabeledValue } from 'core/elements';
import { SelectionCountProvider } from 'core/states';
import { IBreadcrumbsItem } from 'core/types';
import { AddElementTemplateToJobButton } from 'elements/components/ElementTemplateList';
import { PartList } from 'elements/components/PartList';
import { elementTemplateListPath } from 'elements/routes';
import { IElementTemplate } from 'elements/types';

interface IProps {
  elementTemplate: IElementTemplate;
}

export const ElementTemplateDetails = ({ elementTemplate }: IProps) => {
  const { t } = useTranslation();

  const breadcrumbs: IBreadcrumbsItem[] = [
    {
      text: t('titleElementTemplates'),
      to: elementTemplateListPath(),
    },
    {
      text: elementTemplate.customIdentifier,
    },
  ];

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <PageTitle
        title={elementTemplate.customIdentifier}
        subtitle={
          <LabeledValue
            label={t('labelDescription')}
            value={elementTemplate.description}
            options={{ inline: true }}
          />
        }
        buttons={[
          <AddElementTemplateToJobButton key="addToJob" elementTemplate={elementTemplate} />,
        ]}
      />

      <SelectionCountProvider>
        <PartList elementTemplate={elementTemplate} />
      </SelectionCountProvider>
    </>
  );
};
